import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const ComponentRatingChart = ({ trainData }) => {
  if (!trainData) return <p>No data available</p>;

  // Extract the specific rating fields from trainData
  const ratings = [
    ['avgFloorRating', 'coachFloor'],
    ['avgToiletRating', 'toilet'],
    ['avgDustbinRating', 'dustbin']
  ];
  
  const data = ratings
    .filter(([key, component]) => {
      const count = trainData.ratingCounts?.[component];
      return typeof count === 'number' ? count > 0 : Number(trainData[key] || 0) > 0;
    })
    .map(([key]) => ({
      name: key.replace('avg', '').replace('Rating', '').replace(/([A-Z])/g, ' $1').trim(),
      rating: parseFloat(trainData[key].toFixed(1))
    }))
    .sort((a, b) => b.rating - a.rating);

  if (data.length === 0) return <p>No rating data available</p>;

  return (
    <>
      <h3 className="chart-title">Average Component Ratings</h3>
      <div className="chart-wrapper">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 20, right: 30, left: 0, bottom: 50 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="var(--border-color)" />
            <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{fill: 'var(--text-secondary)', fontSize: 12}} angle={-45} textAnchor="end" />
            <YAxis domain={[0, 5]} axisLine={false} tickLine={false} tick={{fill: 'var(--text-secondary)'}} />
            <Tooltip 
              cursor={{fill: 'var(--bg-color)'}} 
              contentStyle={{ borderRadius: '8px', border: '1px solid var(--border-color)', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }} 
            />
            <Bar dataKey="rating" fill="var(--accent-color)" radius={[4, 4, 0, 0]} barSize={40} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </>
  );
};

export default ComponentRatingChart;
